module.exports = __webpack_public_path__ + "static/media/map-view.6042ba37.svg";